/* =====================================================================
 * Result Controls
 * ===================================================================*/

import helpers from '../helpers.js';
import calc from '../simulator/calc.js';
import dataBase from '../simulator/database.js';

(function (doc) {

  const appResult = doc.querySelector('.appResult');
  if (!appResult) return;

  /* ---------------------------------------------------------------------
   * 1. Populate Select Options
   * -------------------------------------------------------------------*/

  const populateSelectOptions = (select, correctives) => {
    for (let key in correctives) {
      const option = doc.createElement('option');
      const currentCorrective = correctives[key];
      option.text = [
        currentCorrective.name,
        currentCorrective.type,
        currentCorrective.city,
        currentCorrective.uf
      ].join(' - ');
      option.value = key;
      select.appendChild(option);
    }

    select.disabled = false;
  };

  /* ---------------------------------------------------------------------
   * 2. Update Correctives Values
   * -------------------------------------------------------------------*/

  const updateValues = (row, correctives, correctiveKey) => {
    ['cao', 'mgo', 'prnt'].forEach((field) => {
      const element = row.querySelector('.correctives-result-' + field);
      element.innerHTML = correctives[correctiveKey][field];
    });
  };

  /* ---------------------------------------------------------------------
   * 3. Update Dose
   * -------------------------------------------------------------------*/

  const updateDose = (row) => {
    const vone = row.querySelector('[name="inputVone"]');
    const vtwo = row.querySelector('[name="inputVtwo"]');
    const measure = doc.querySelector('.select-measures');
    const ctc = row.querySelector('[name="inputCtc"]');
    const prnt = row.querySelector('.correctives-result-prnt');

    if (!vone || !vone || !measure || !ctc || !prnt) return;

    const calculateDose = calc.corrective.dose;
    const calcParams = [vone.value, vtwo.value, measure.value, ctc.value, prnt.innerHTML];

    row.querySelector('.correctives-result-dose').innerHTML = calculateDose(...calcParams);
    helpers.triggerEvent(row, 'updatedDose');
  };

  /* ---------------------------------------------------------------------
   * 4. Update Estimated Position
   * -------------------------------------------------------------------*/

  const updateEstimatedPosition = () => {
    const rows = doc.querySelectorAll('.estimatedPosition-result');
    for (let key = 1; key < rows.length; key++) {
      const row = rows[key];
      const formRow = doc.querySelectorAll('.app-data')[key - 1];
      const baseRow = doc.querySelectorAll('.basePosition-result')[key];
      const correctiveRow = doc.querySelectorAll('.correctives-result')[key];

      const calculate = calc.estimatedPosition;
      const baseClass = '.estimatedPosition-result-';
      const ca = formRow.querySelector('[name="input-ca"]').value;
      const mg = formRow.querySelector('[name="input-mg"]').value;
      const ctc = formRow.querySelector('[name="input-ctc"]').value;

      const vone = formRow.querySelector('[name="input-v-one"]').value;
      const vtwo = formRow.querySelector('[name="input-v-two"]').value;

      const dose = correctiveRow.querySelector('.correctives-result-dose').innerHTML;
      const measure = doc.querySelector('.select-measures').value;
      const ajuste = correctiveRow.querySelector('[name="input-ajuste"]').value;
      const cao = correctiveRow.querySelector('.correctives-result-cao').innerHTML;
      const mgo = correctiveRow.querySelector('.correctives-result-mgo').innerHTML;
      const prnt = correctiveRow.querySelector('.correctives-result-prnt').innerHTML;

      const calculatedCTCcalcio = baseRow.querySelector('.basePosition-result-ctcCalcio').innerHTML;
      const calculatedCTCmagnesio = baseRow.querySelector('.basePosition-result-ctcMagnesio').innerHTML;

      /* ---------------------------------------------------------------------
       * 4.1. Cálcio
       * -------------------------------------------------------------------*/

      const mmolCalcioParams = [
        dose,
        measure,
        ajuste,
        cao,
        prnt,
        formRow.querySelector('[name="input-ca"]').value
      ];
      const mmolCalcioResult = calculate.mmolCalcio(...mmolCalcioParams);
      row.querySelector(baseClass + 'mmolCalcio').innerHTML = mmolCalcioResult;

      const ctcCalcioParams = [dose, mmolCalcioResult, ctc, calculatedCTCcalcio];
      const ctcCalcioResult = calculate.ctcCalcio(...ctcCalcioParams);
      row.querySelector(baseClass + 'ctcCalcio').innerHTML = ctcCalcioResult;

      const teorCalcioResult = calculate.teorCalcio(ctcCalcioResult);
      row.querySelector(baseClass + 'teorCalcio').innerHTML = teorCalcioResult;

      /* ---------------------------------------------------------------------
       * 4.1. Magnésio
       * -------------------------------------------------------------------*/

      const mmolMagnesioParams = [
        dose,
        measure,
        ajuste,
        mgo,
        prnt,
        formRow.querySelector('[name="input-mg"]').value
      ];
      const mmolMagnesioResult = calculate.mmolMagnesio(...mmolMagnesioParams);
      row.querySelector(baseClass + 'mmolMagnesio').innerHTML = mmolMagnesioResult;

      const ctcMagnesioParams = [dose, mmolMagnesioResult, ctc, calculatedCTCmagnesio];
      const ctcMagnesioResult = calculate.ctcMagnesio(...ctcMagnesioParams);
      row.querySelector(baseClass + 'ctcMagnesio').innerHTML = ctcMagnesioResult;

      const teorMagnesioResult = calculate.teorMagnesio(ctcMagnesioResult);
      row.querySelector(baseClass + 'teorMagnesio').innerHTML = teorMagnesioResult;

      /* ---------------------------------------------------------------------
       * 4.2. Ca/Mg
       * -------------------------------------------------------------------*/

      const camgParams = [dose, ca, mg, ctcCalcioResult, ctcMagnesioResult];
      const camgResult = calculate.camg(...camgParams);
      row.querySelector(baseClass + 'camg').innerHTML = camgResult;

      /* ---------------------------------------------------------------------
       * 4.3. V2
       * -------------------------------------------------------------------*/

      const vtwoParams = [dose, ajuste, measure, vone, vtwo, prnt, ctc];
      const vtwoResult = calculate.vtwo(...vtwoParams);
      row.querySelector(baseClass + 'vtwo').innerHTML = vtwoResult;

    }
  };

  /* ---------------------------------------------------------------------
   * 4. Event Listeners
   * -------------------------------------------------------------------*/

  doc.addEventListener('updatedResults', () => {
    const selectCorrectives = appResult.querySelectorAll('.select-correctives');
    Array.prototype.forEach.call(selectCorrectives, (select) => {
      const correctives = dataBase.correctives;
      const currentRow = helpers.getParentByClass(select, 'correctives-result');

      populateSelectOptions(select, correctives);
      updateValues(currentRow, correctives, select.value);
      updateDose(currentRow);
      updateEstimatedPosition();

      select.addEventListener('change', () => {
        updateValues(currentRow, correctives, select.value);
        updateDose(currentRow);
        updateEstimatedPosition();
      });
    });

    const inputsAjuste = appResult.querySelectorAll('[name="input-ajuste"]');
    Array.prototype.forEach.call(inputsAjuste, (input) => {
      input.addEventListener('input', () => updateEstimatedPosition());
    });

    const measure = doc.querySelector('.select-measures');
    measure.addEventListener('input', () => {
      const rows = doc.querySelectorAll('.correctives-result');
      Array.prototype.forEach.call(rows, (row) => updateDose(row));
      updateEstimatedPosition();
    });
  });

}(document));
